import { ReactElement } from 'react';
import { usePageTracking } from './hooks/usePageTracking';

export function AppEffects(): ReactElement {
  usePageTracking();

  return null;
}
